/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, cap: NonNullable<unknown> }} Players_Count_CappedInputs */



/**
* | output |
* | --- |
* | "{count} / {cap} players" |
*
* @param {Players_Count_CappedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_count_capped = /** @type {((inputs: Players_Count_CappedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Count_CappedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} / ${i?.cap} joueurs`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} / ${i?.cap} jugadores`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} / ${i?.cap} jogadores`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} / ${i?.cap} giocatori`)
	return /** @type {LocalizedString} */ (`${i?.count} / ${i?.cap} players`)
});